<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <div class="order-detail-box" v-if="selectTab === 3">
          <div class="label-val">
            <div class="label-1">司机姓名</div>
            <div class="value-1">{{ detail.username }}</div>
          </div>
          <div class="label-val">
            <div class="label-1">联系电话</div>
            <div class="value-1">{{ detail.phone }}</div>
          </div>
        </div>
        <div class="order-detail-box order-detail-box1" v-else>
          <div class="label-val">
            {{ detail.companyName }}
          </div>
        </div>
        <template>
          <el-row :gutter="20">
            <el-form ref="form" :model="form" :rules="rules" label-position="top">
              <el-col :span="24">
                <el-form-item label="充值金额：" prop="rechargeAmount">
                  <el-input
                    v-model="form.rechargeAmount"
                    clearable
                    style="width: 50%"
                    autocomplete="off"
                    placeholder="请输入">
                    <template slot="append">元</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="充值凭证：" prop="vouchers">
                  <upload-files2 v-model="form.vouchers"></upload-files2>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="备注：" prop="remark">
                  <el-input
                    type="textarea"
                    clearable
                    rows="5"
                    placeholder="请输入备注"
                    v-model="form.remark"
                    show-word-limit
                    maxlength="50"></el-input>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
        </template>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import UploadFiles2 from "@/components/UploadFiles4.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomCopy from "@/components/CustomCopy.vue";
import { getFileUrl } from "@/utils/tool";
import { getLocalLabel } from "@/utils/localDict";
import { validatePrice } from "@/utils/validate";
import { platformRecharge } from "@/views/commonApi";
import {rechargeCompany, rechargeDriver} from "@/views/FinancialManagement/WalletManagement/api";
export default {
  name: "AddOrEdit",
  components: {
    CustomCopy,
    CustomTable,
    UploadFiles2,
    DialogContainer,
  },
  data() {
    return {
      cheImage: require("@/assets/imgs/title.png"),
      imageUrl: require("@/assets/imgs/bg.png"),
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "30%",
        show: false,
        title: "钱包充值",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      form: {
        rechargeAmount: "",
        remark: "",
        userId: "",
        companyId: "",
        vouchers: [],
      },
      detail: {},
      rules: {
        vouchers: [{ required: true, message: "处理凭证不能为空" }],
        rechargeAmount: [
          { required: true, message: "充值金额不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
      },
      isDetail: false,
      selectTab: null
    };
  },
  mounted() {},
  methods: {
    getLocalLabel,
    getFileUrl,
    init(selectTab, row) {
      this.selectTab = selectTab
      this.form.userId = row.userId;
      this.form.vouchers = []
      this.form.companyId = row.companyId;
      if (!!row) {
        this.detail = Object.assign({}, row);
      }
      this.dialogObj.show = true;
    },
    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          let methodApi = ""
          if (this.selectTab === 3) {
            methodApi = rechargeDriver;
          } else {
            methodApi = rechargeCompany;
          }
          methodApi(this.form)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success("充值成功");
                this.$parent.handleAddOrEditSuccess("edit");
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .order-detail-box {
    display: flex;
    width: 100%;
    height: 0.8rem;
    background: #f7fbff;
    padding: 0.1rem;
    border-radius: 0.08rem;
    box-sizing: border-box;
    margin-bottom: 0.2rem;
    .label-val {
      width: 33.3%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      .label-1 {
        color: #8c8c8c;
        font-size: 0.12rem;
        padding-bottom: 0.06rem;
      }
      .value-1 {
        color: #434343;
      }
    }
    .label-val:after {
      content: "";
      position: absolute;
      right: 0;
      width: 0.01rem;
      height: 0.26rem;
      background: #dce5f5;
    }
    .label-val:nth-last-of-type(1):after {
      display: none;
    }
  }
  .order-detail-box1{
    .label-val{
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
    }
  }
  .title-box {
    padding: 0rem 0 0.1rem;
    color: #000000;
    .title-label {
      width: 0.08rem;
      height: 0.08rem;
      margin-right: 0.06rem;
    }
  }
  .common-info-box {
    padding: 0.1rem;
    box-sizing: border-box;
    background: #f7f8fb;
    line-height: 0.24rem;
    border-radius: 0.08rem;
  }
  .common-image-box {
    margin-bottom: 0;
    margin-top: 0.04rem;
  }
  .invice-info {
    line-height: 0.24rem;
    margin-bottom: 0.2rem;
  }
  .radio-box {
    display: flex;
    align-items: center;
    span {
      font-size: 0.12rem;
      color: #8c8c8c;
    }
  }
}
</style>
